import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  notifications: [],
  unreadCount: 0,
  anchorEl: null,
  deleteNotification: null,
};

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    setNotifications: (state, action) => {
      state.notifications = action.payload;
      state.unreadCount = action.payload.filter((n) => !n.read).length;
    },
    clearUnreadCount: (state) => {
      state.unreadCount = 0;
    },
    setAnchorEl: (state, action) => {
      state.anchorEl = action.payload;
    },
    resetAnchorEl: (state) => {
      state.anchorEl = null;
    },
    deleteNotification: (state, action) => {
      state.notifications = [];
    },
  },
});

export const {
  addNotification,
  clearUnreadCount,
  setAnchorEl,
  resetAnchorEl,
  deleteNotification,
  setNotifications,
} = notificationsSlice.actions;
export default notificationsSlice.reducer;
